import PropTypes from 'prop-types';
import React from 'react';
import Warn, { WARN_STANDARD_VARIANT } from 'app/components/svgs/Warn';
import { PURE_WHITE, PURE_RED } from 'app/constants/Colors';
import { BORDER_RADIUS_A, BOX_SHADOW_B } from 'app/constants/Styles';
import { T } from 'app/components/localization';
import ReloadButton from 'app/components/common/ReloadButton';
import { getGlobalHistory } from 'app/services/history';

const styles = {
  hiddenContainer: {
    display: 'none',
  },

  visibleContainer: {
    backgroundColor: PURE_WHITE,
    border: `2px solid ${PURE_RED}`,
    borderRadius: BORDER_RADIUS_A,
    boxSizing: 'border-box',
    boxShadow: BOX_SHADOW_B,
    fontSize: '16px',
    padding: '0.4em 1em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  message: {
    margin: '0 0.8em',
    textAlign: 'center',
    verticalAlign: 'middle',
  },

  buttonContainer: {
    flexShrink: 0,
  },

  warnContainer: {
    flexShrink: 0,
  },
};

const ReloadRequiredNotifier = ({ visible }) => {
  const reload = () => getGlobalHistory().reload();

  return (
    <T>{t =>
      <div style={visible ? styles.visibleContainer : styles.hiddenContainer}>
        <span style={styles.warnContainer}>
          <Warn size="1.6em" variant={WARN_STANDARD_VARIANT} />
        </span>
        <span style={styles.message}>
          {t('header.refresh-required-notifier.message')}
        </span>
        <span style={styles.buttonContainer}>
          <ReloadButton onClick={reload}>
            {t('header.refresh-required-notifier.button')}
          </ReloadButton>
        </span>
      </div>
    }</T>
  );
};

ReloadRequiredNotifier.propTypes = {
  visible: PropTypes.bool,
};

export default ReloadRequiredNotifier;
